import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLightning"><Path d="M3.5 12.5L8.79412 2.5H18L15 8.5H21L7 20.5L9.5 12.5H3.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconLightning;
